module.exports = __webpack_public_path__ + "img/c02_unitfireshipchampion_Normal_ua.ad09d243.webp";